import { useState, useEffect } from 'react';
var useProgress = function (intervalSeconds, currentPage, totalClients, clientsPerPage, isPaused) {
    var _a = useState(0), progress = _a[0], setProgress = _a[1];
    useEffect(function () {
        // Reinicia o progresso quando muda de página ou quando o pause é desativado
        setProgress(0);
    }, [currentPage, isPaused]);
    useEffect(function () {
        if (isPaused || progress >= 100)
            return;
        var progressInterval = setInterval(function () {
            setProgress(function (prevProgress) {
                var increment = 100 / (intervalSeconds * 10);
                var newProgress = prevProgress + increment;
                return newProgress >= 100 ? 100 : newProgress;
                // return 0;
            });
        }, 100);
        return function () { return clearInterval(progressInterval); };
    }, [intervalSeconds, isPaused, progress]); // Adicionamos progress como dependência
    return progress;
};
export default useProgress;
